
import StatusBadge from "./StatusBadge.vue";
import {
  formatBytes,
  formatDateTime,
  formatPeriodo,
  labelStatusArquivo,
  labelStatusEmailLog,
  labelTipoExecucao,
} from "@/modules/envio-contabilidade/utils";

export default {
  name: "EnvioContabilidadeExecucaoDetalheModal",
  components: {
    StatusBadge,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    execucao: {
      type: Object,
      default: null,
    },
  },
  computed: {
    arquivos() {
      return this.execucao && Array.isArray(this.execucao.arquivos)
        ? this.execucao.arquivos
        : [];
    },
    emailLogs() {
      return this.execucao && Array.isArray(this.execucao.email_logs)
        ? this.execucao.email_logs
        : [];
    },
    temPacote() {
      return Boolean(this.execucao && (this.execucao.zip_url || this.execucao.zip_path));
    },
  },
  methods: {
    formatBytes,
    formatDateTime,
    formatPeriodo,
    labelStatusArquivo,
    labelStatusEmailLog,
    labelTipoExecucao,
    labelTipoEmail(tipo) {
      const labels = {
        to: "Destinatários",
        cc: "Cópia",
        bcc: "Cópia oculta",
      };

      return labels[tipo] || tipo || "-";
    },
  },
};
